<template>
    <div class="instruction" style="z-index: 1000">
        <div class="item" v-if="stage === 'first'">
            <img src="@/assets/images/rule_2.png"/>
            <img style="margin-top: -1px" src="@/assets/images/rule_3.png"/>
        </div>
        <div v-else class="item">
            <img src="@/assets/images/second-rule.png" alt="">
        </div>
    </div>
</template>

<script>
    export default {
        name: "ActivityRule",
        data () {
            return {
                stage: 'first'
            }
        },
        created () {
            this.stage = this.$route.query.stage
        }
    }
</script>

<style scoped>
    .instruction {
        position: fixed;
        top:0;
        left:0;
        width: 100%;
        height: 100vh;
        overflow: scroll;
        background-color: #FD7759;
        z-index: 1000;
    }
    .instruction .item {
        width: 100%;
        padding: 0;
        margin: 0;
    }

    .instruction .item img {
        width: 100%;
        display: block;
    }
</style>